<template>
    <li class="answer-button"
        :class="{
          'answer-button-selected': isSelected,
          'answer-button-not-selected': !isSelected
        }"
    >
        
        <div
            v-html="answerText"
            class="answer-button-text">            
        </div>

    </li>
</template>

<script>
export default {
    name: "UniversalAnswerButton",
    props: {
        answerText: String,
        isSelected: Boolean,
        isDisable: Boolean
    }
}
</script>

<style>
    
</style>